/*!
  mobify-theme, by logicgo infotech Themes
  https://logicgoinfotech.com
*/
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
$(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:section:reorder', this._onReorder.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function _createInstance(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },
  _onSectionLoad: function _onSectionLoad(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function _onSectionUnload(evt) {
    this.instances = _.filter(this.instances, function (instance) {
      var isEventInstance = instance.id === evt.originalEvent.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function _onSelect(evt) {

    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function _onDeselect(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },
  _onReorder: function _onReorder(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onReorder)) {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function _onBlockSelect(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function _onBlockDeselect(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {       
      instance.onBlockDeselect(evt);
    }
  },

  register: function register(type, constructor) {
    this.constructors[type] = constructor;
    $('[data-section-type=' + type + ']').each(function (index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

theme.HomeSlideshow = function () {
  function HomeSlideshow(container) {

    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sliderActive = this.sliderActive = $('#home-slider-' + sectionId).length;
    var sliderSpeed = $container.attr('data-animation-speed');
    var sliderAuto = $container.attr('data-autoPlay');
    if (sliderAuto == 'true') var autoplay = sliderSpeed > 0 ? {
      delay: +sliderSpeed
    } : false;else {
      autoplay = "false";
    }
    var slidesCount = $('#home-slider-' + sectionId + ' .swiper-slide').length;
    if (slidesCount > 1) {
      var loop = true;
      var simulateTouch = true;
    } else {
      var loop = false;
      var simulateTouch = false;
    }
    var lgSlider = this.lgSlider = new Swiper('#home-slider-' + sectionId, {
      navigation: {
        nextEl: '#swiper-button-next-' + sectionId,
        prevEl: '#swiper-button-prev-' + sectionId
      },
      direction: 'horizontal',
      loop: loop,
      simulateTouch: simulateTouch,
      pagination: {
        el: '#swiper-pagination-' + sectionId,
        clickable: true
      },
      autoplay: autoplay,
      autoHeight: true
    });
  }

  return HomeSlideshow;
}();

theme.HomeSlideshow.prototype = _.assignIn({}, theme.HomeSlideshow.prototype, {

  onBlockSelect: function onBlockSelect(evt) {
    var sectionId = this.sectionId;
    var slideIndex = $(evt.target).data('index');
    var lgSlider = this.lgSlider;
    var lgSliderMobile = this.lgSliderMobile;
    lgSlider.slideTo(slideIndex, 1500, false);
    lgSlider.autoplay.stop();
  },
  onBlockDeselect: function onBlockDeselect() {
    var sectionId = this.sectionId;
    var lgSlider = this.lgSlider;
    var lgSliderMobile = this.lgSliderMobile;
    lgSlider.autoplay.start();
  }
});

$('.images').slick({
    infinite: true,
    margin:10,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: '<i class="fa-light fa-chevron-left"></i>',
    nextArrow: '<i class="fa-light fa-chevron-right"></i>',
  });

if ($("div.js-slick-carousel").length > 0) {
              	var slick = $("div.js-slick-carousel");
                slick.each(function(){
                  
                  var slidestoshow = $(this).data('slidestoshow');
              	  var slidestoscroll = $(this).data('slidestoscroll');
                  
                  var slidestoshowipadpro = $(this).data('slidestoshowipadpro');
              	  var slidestoscrollipadpro = $(this).data('slidestoscrollipadpro');
                  
                  var slidestoshowipad = $(this).data('slidestoshowipad');
              	  var slidestoscrollipad = $(this).data('slidestoscrollipad');
                  
                  var slidestoshowmobile = $(this).data('slidestoshowmobile');
              	  var slidestoscrollmobile = $(this).data('slidestoscrollmobile');
                  
                  var slidestoshowmobilevertical = $(this).data('slidestoshowmobilevertical');
              	  var slidestoscrollmobilevertical = $(this).data('slidestoscrollmobilevertical');
                  
                  var rows = $(this).data('rows');
                  var arrows = $(this).data('arrows');
                  var dots = $(this).data('dots');
                  var autoplay = $(this).data('autoplay');
                  var infinite = $(this).data('infinite');
                  var appendDots = $(this).parent().find('.laber_append_dots');
                  var settings = {
                        lazyLoad:'ondemand',
                        slidesToShow: slidestoshow,
                        slidesToScroll: slidestoscroll,
                        arrows: arrows,
                        dots: dots,
                        pauseOnHover:true,
                        autoplay: autoplay,
                        autoplaySpeed:'5000',
                        infinite: infinite,
                        appendDots: appendDots,
                  		responsive: [
                          	{
                                breakpoint: 1400,
                                settings: {
                                    dots: true,
                                    arrows: false,
                                    infinite: false,
                                  	autoplay: autoplay,
                                    slidesToShow: slidestoshowipadpro,
                                    slidesToScroll: slidestoscrollipadpro
                                }
                            },
                            {
                                breakpoint: 1024,
                                settings: {
                                    dots: true,
                                    arrows: false,
                                    infinite: false,
                                  	autoplay: autoplay,
                                    slidesToShow: slidestoshowipad,
                                    slidesToScroll: slidestoscrollipad
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    dots: true,
                                    arrows: false,
                                  	autoplay:true,
                                    infinite: false,
                                    slidesToShow: slidestoshowmobile,
                                    slidesToScroll: slidestoscrollmobile
                                }
                            },
                          	{
                                breakpoint: 480,
                                settings: {
                                    dots: true,
                                    arrows: false,
                                  	autoplay:true,
                                    infinite: false,
                                    slidesToShow: slidestoshowmobilevertical,
                                    slidesToScroll: slidestoscrollmobilevertical
                                }
                            }
                          
                        ]
                  };
                  	
                  if(rows){
                    $.extend(settings, {
                        rows: rows,
                    });
                  }
                  
                  $(this).slick(settings);
                          
                })
               }

$(document).ready(function($) {

  $('#nothanks').on('click', function () {
    if (!jQuery.cookie('brilliant_pop_newletter') || jQuery.cookie('brilliant_pop_newletter') == null) {    
      $(window).on('load', function(){
        setTimeout($('.jsengo_popup').show(), 300 * 1000);
        jQuery('.jsclosepoup').click(function(e) {
          e.preventDefault();
          jQuery('.jsengo_popup').hide(); 
          jQuery.cookie('brilliant_pop_newletter', '1', {expires: 1, path:'/', domain: '' });
                                                        });
        });
      }
    else {
        $('.jsengo_popup').remove();
    }
  });
   
  
  
   $('.jsclosepoup').on('click', function() {
      $('.jsengo_popup').addClass('d-none');
    });


	$(".tab_content").hide();
	$(".tab_content:first").show(); 

	$("ul.tabs-grid li").click(function() {
		$("ul.tabs-grid li").removeClass("active");
		$(this).addClass("active");
		$(".tab_content").hide();
		$(".tab_content").removeClass("animate1");
		var activeTab = $(this).attr("rel"); 
		$("#"+activeTab).addClass("animate1");
		$("#"+activeTab).fadeIn();
	});
	
	$(".tab_slider").hide();
	$(".tab_slider:first").show(); 

	$("ul.tabs-slider li").click(function() {
		$("ul.tabs-slider li").removeClass("active");
		$(this).addClass("active");
		$(".tab_slider").hide();
		$(".tab_slider").removeClass("animate1");
		var activeTab = $(this).attr("rel"); 
		$("#"+activeTab).addClass("animate1");
		$("#"+activeTab).fadeIn();
	});	
	
	var owl = $(".productTabContent");
	if(owl.length > 0){
		owl.owlCarousel({
			items :4,
			navSpeed: 1000,
			dots :true,
			nav : false,
			loop: true,
			mouseDrag: true,
			touchDrag: true, 
			responsive:{
				0:{  
					items:1
				},
				480: {  
					items:2
				},
				640: {  
					items:3
				},
				991: {
					items:3	
				},
				1200:{
					items:4
				}
			},
		});
	}
});

  

$(document).ready(function () {
 
  var sections = new theme.Sections();
  sections.register('slideshow-section', theme.HomeSlideshow);

  $(document).on('shopify:section:select', function (e) {
    var $target = $(e.target),
        sectionID = e.originalEvent.detail.sectionId,
        $handle = $('#shopify-section-handle-' + sectionID),
        handle_class = $handle.length ? $handle.attr('data-bg-type') : null;
    if (handle_class) {
      $target.addClass(handle_class);
    }
  });
;
	


});

$( window ).resize(function() {
	
  
});	

function currencyFormSubmit(event) {
    event.target.form.submit();
  }
  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });




//Quick view Script Start
  $(document).on("click",".quick-view",function() {
  	var handle = $(this).data("handle");
    loadQuickView(handle, $(this));
  });
  //Quick view Script End


//Quick view Functions Start

var variantAvailability = [];
var variantFeaturedImg = [];
var variantIndexIdMapping = [];
var currentVariants = {};
var availableVariants = [];
var variantCompareAtPrice = [];
var variantPrice = [];

function loadQuickView(handle,btn) {
  variantAvailability = [];
  variantFeaturedImg = [];
  variantIndexIdMapping = [];
  currentVariants = {};
  availableVariants = [];
  variantCompareAtPrice = [];
  variantPrice = [];
  $("#qv-variants").html('');
  
  jQuery.getJSON('/products/' + handle + '.js', function (product) {
    $("#qv-productname").html(product.title);
    $("#qv-productdescription").html(product.description);
    if(product.description.length < 300) {
    	$(".more-description").css("display","none");
    }else{
        $(".more-description").css("display","block");
    }
    $("#qv-product-cover img").attr("src",product.featured_image);
    var reviews = $('[data-handle="'+ handle +'"]').parents(".card-wrapper").find(".spr-badge").clone();
    $("#qv-spr-badge").html(reviews.html());

    //prepare thumbnails
    prepareQvThumbnails(product.images);

    if(product.variants.length > 1) {
      //prepare swatches
      var colorNameList = "color,colour,couleur,colore,farbe,색,色,färg,farve";
      colorNameList = colorNameList.split(",");
      $(product.options).each(function (i, option) {
        var name = option.name;
        var includesColor = colorNameList.includes(name.toLowerCase());
        var swatchWrapper = $('<div class="swatch-wrapper" data-index="' + option.position + '"></div>');
         var optionValues =  $('<div class="option-values product-form__input ' + name.toLowerCase() +'"></div>');
        swatchWrapper.append('<div class="option-label"><label>' + name + '</label></div>')
        $(option.values).each(function (i, value) {
          var checked = '';
          if(i==0) checked = 'checked';
          optionValues.append('<input id="' + name + '-' + i + '" type="radio" value="' + value + '" name="' + name +'"' + checked  +'>');
          var className = (includesColor || value.length < 3) ? "square" : "label"; 
          if(includesColor) {
            var dummyImg = "//benergo.eu/cdn/shop/files/dummy?601";
            var dummyImgURL = dummyImg.substr(0, dummyImg.indexOf('dummy'));
            var dummyImgVersion = dummyImg.substr(dummyImg.indexOf('?'));
            var imgURL = "background-color:" + value + "; background-image: url('"+ dummyImgURL + value + ".png" + dummyImgVersion +"')";
          	optionValues.append('<label style="'+ imgURL + '" for="' + name + '-' + i + '" class="' + className +'" data-index="'+ i +'"></label>');
          } else {
            optionValues.append('<label for="' + name + '-' + i + '" class="' + className +'" data-index="'+ i +'">' + value + '</label>');
          }
          
        });
        swatchWrapper.append(optionValues);
        $("#qv-variants").append(swatchWrapper);
      });    

      //prepare dropdown
      $(product.options).each(function (i, option) {
        var name = option.name;
        var selectWrapper = $('<div class="dropdown-wrapper"></div>');
        var optionValues = $('<div class="option-values product-form__input"></div>');
        var selectBoxWrapper =  $('<div class="select"></div>');
        var selectBox =  $('<select id="select-option' + option.position + '" name="options[' + option.position + ']" class="select__select"></select>');
        selectWrapper.append('<div class="option-label"><label>' + name + '</label></div>')
        $(option.values).each(function (i, value) {
          var selected = '';
          if(i==0) selected = 'selected';
          selectBox.append('<option value="' + value +'" ' + selected +'>' + value + '</option>');
        });
        selectBoxWrapper.append(selectBox);
        optionValues.append(selectBoxWrapper);
        selectWrapper.append(optionValues);
        $("#qv-variants").append(selectWrapper);
      });
      
      $(product.variants).each(function(index,variant) {
        var variantsList = variant.title.split("/");
        var variantsKeyVal = {};
        for(var i=0; i < variantsList.length; i++) {
          variantsKeyVal["select-option" + (i+1)] = variantsList[i].trim();
        }
        variantIndexIdMapping.push(variant.id);
        availableVariants.push(variantsKeyVal);
        variantAvailability.push(variant.available);
        
        variantCompareAtPrice.push(variant.compare_at_price);
        variantPrice.push(variant.price);
      });
      loadCurrentQvVariants();
      updateQvVariantDetails();
    } else {
      var variant = product.variants[0];
      $("#qv-variantid").val(variant.id);
      if(variant.available){
      	$("#qv-add-to-cart").removeClass("sold-out");
      } else {
      	$("#qv-add-to-cart").addClass("sold-out");
      }
      if(variant.compare_at_price != null && variant.compare_at_price > variant.price) {
        $("#qv-compareatprice").html(convertToMoney(variant.compare_at_price));
        $("#qv-price").html(convertToMoney(variant.price));
      } else {
        $("#qv-compareatprice").html('');
        $("#qv-price").html(convertToMoney(variant.price));
      }
      
    }
    $('.qv-wrapper').removeClass('loading');
  });
}

function addToCartJS(qty,variantID, btn) {   
    var xhr = new XMLHttpRequest();
    var url = "/cart/add.js";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
          var parsedState = JSON.parse(xhr.responseText);
          window.scrollTo({top: 0, behavior: 'smooth'});
          document.querySelector('cart-notification').renderContents(parsedState);
		  btn.classList.remove("loading");
      }
    };
    var sectionsToRender = ["cart-notification-product", "cart-notification-button", "cart-icon-bubble"];
    var sections_url = window.location.pathname;
    var data = JSON.stringify({"quantity": qty, "id": variantID, "sections" : sectionsToRender, "sections_url" : sections_url });
    xhr.send(data);
}

function convertToMoney(price) {
  var price = parseFloat(price / 100).toFixed(2);
  var currency = document.getElementsByTagName("html")[0].getAttribute("currency");
  return currency + price; 
}

function prepareQvThumbnails(images) {
	var thumbnailContainer = $('#qv-thumbnails');
    var thumbnailSliderWrapper = $('<div class="owl-carousel"></div>')
    $(images).each(function (i,src) {
      thumbnailSliderWrapper.append('<div class="thumb-item item"><img src="' + src +'" alt="qv-img" ></div>');
    });
    thumbnailContainer.html(thumbnailSliderWrapper);
    thumbnailSliderWrapper.owlCarousel({
      nav: true,
      dots: false,
      navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z"/></svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z"/></svg>'
      ],
      loop: false,
      margin:15,
      rewind:true,
      responsive: {
        0: {
          items: 3
        },
        544: {
          items: 4
        },
        768: {
          items: 3
        },
        992: {
          items: 4
        },
        1200: {
          items: 4
        }
      }
  	});

}

function loadCurrentQvVariants() {
  //load current variants
  $('#qv-variants .dropdown-wrapper').each(function(index){
    currentVariants["select-option" + (index+1)] = $(this).find('select.select__select').val();
  });
}

function updateQvVariantDetails() {
  var index=0;
  var available = false;
  for(var i=0; i < availableVariants.length;) {
    if(matchArray(availableVariants[i],currentVariants)) {
      index = i;
    }
    if(matchArray(availableVariants[i],currentVariants) && variantAvailability[i]) {
      available = true;
      break;
    }
     i++;
  }
  
  $("#qv-variantid").val(variantIndexIdMapping[index]);
  
  if(available){
    $("#qv-add-to-cart").removeClass("sold-out");
  } else {
    $("#qv-add-to-cart").addClass("sold-out");
  }
  
  $("#qv-product-cover img").attr("src", variantFeaturedImg[index]);
  
   var price = variantPrice[index];
  var compare_at_price = variantCompareAtPrice[index];
  if(compare_at_price != null && compare_at_price > price) {
    $("#qv-compareatprice").html(convertToMoney(compare_at_price));
    $("#qv-price").html(convertToMoney(price));
  } else {
    $("#qv-compareatprice").html('');
    $("#qv-price").html(convertToMoney(price));
  }
  
}

function matchArray(a, b) {
  var match = true;
  for (var key in a) {
    if(a[key] != b[key]) {
      match = false;
    }
  }
  return match;
}

$(document).on("change","#qv-variants .select__select",function(){
  loadCurrentQvVariants();
  updateQvVariantDetails();
});
 
$(document).on("click",".swatch-wrapper label",function() {
  var selectorIndex = $(this).parents(".swatch-wrapper").data("index");
  var selector = "#select-option" + selectorIndex  + " option";
  var index = $(this).data("index");
  $(selector).eq(index).prop('selected', true).trigger('change');
});

$(document).on("click",".thumb-item",function(){
  $("#qv-product-cover img").attr("src",$(this).find("img").attr("src"))
});
 //Cart Buttons Script Start
  $(document).on("click",".add-to-cart-js",function() {
  	var variantID = this.getAttribute("data-variantid");
    $(this).addClass("loading");
    addToCartJS(1, variantID, this);
  });
  
  $(document).on("click",".cart-remove-js",function() {
  	var variantID = this.getAttribute("data-variantid");
    removeFromCartJS(variantID);
  });
  //Cart Buttons Script End
$(document).on("click","#qv-add-to-cart",function(){
  if($(this).hasClass("sold-out")) return false;
  var variantId = $("#qv-variantid").val();
  var qty = $("#qv-quantity-selector input").val();
  $(this).addClass("loading");
  addToCartJS(qty,variantId, this);
  $("#ModalClose-quick-view").trigger("click");
});

//Quick view Functions End
             
 //Default Collapse Javascript Start
  $(document).on("click","[data-toggle='collapse']",function() {
    var parent = $(this).data("parent");
    var target = $(this).data("href");
    if($(parent).length && $(parent).hasClass('panel-group')) {
     $(parent+" .panel").each(function() {
       var p = $(this).find("[data-toggle='collapse']");
       var t = p.data("href");
       if(t!= target && p.attr("aria-expanded") == "true") {
        $(t).slideUp().removeClass("in");
        p.addClass("ishi-collapsed").attr("aria-expanded","false");
       } 
     });
    } 
    if($(this).attr("aria-expanded") == "false") {
      $(target).slideDown().addClass("in");
      $(this).removeClass("ishi-collapsed").attr("aria-expanded","true");
    } else {
      $(target).slideUp().removeClass("in");
      $(this).addClass("ishi-collapsed").attr("aria-expanded","false");
    }
  });
  //Default Collapse Javascript End
  
 //Default Popover Javascript Start
  $(document).on("click","[data-toggle='popover']",function() {
    var target = $(this).data("href");
    if($(this).attr("aria-expanded") == "false") {
      $(target).addClass("active");
      $(this).attr("aria-expanded","true");
    } else {
      $(target).removeClass("active");
      $(this).attr("aria-expanded","false");
    }
  });
$(document).on("click","#ModalClose-quick-view",function() {
$("#qvPopupModal").removeClass("active");
      $('.product-popup-modal__button').attr("aria-expanded","false");  
   });
  
  $(document).on("click", function(event){
    if(!$(event.target).closest('#search-container-full').length && !$(event.target).closest('[data-href="#search-container-full"]').length){
      if($('[data-href="#search-container-full"]').attr("aria-expanded") == "true") {
        $("#search-container-full").removeClass("active");
        $('[data-href="#search-container-full"]').attr("aria-expanded","false");
      }
    }
    
    if(!$(event.target).closest('#user-notification').length && !$(event.target).closest('[data-href="#user-notification"]').length){
      if($('[data-href="#user-notification"]').attr("aria-expanded") == "true") {
        $("#user-notification").removeClass("active");
        $('[data-href="#user-notification"]').attr("aria-expanded","false");
        event.preventDefault();
      }
    }
    
    if(!$(event.target).closest('#cart-notification').length && !$(event.target).closest('[data-href="#cart-notification"]').length){
      if($('[data-href="#cart-notification"]').attr("aria-expanded") == "true") {
        $("#cart-notification").removeClass("active");
        $('[data-href="#cart-notification"]').attr("aria-expanded","false");
      }
    }
    
    if(!$(event.target).closest('#HeaderCountryList').length && !$(event.target).closest('[data-href="#HeaderCountryList"]').length){
      if($('[data-href="#HeaderCountryList"]').attr("aria-expanded") == "true") {
        $("#HeaderCountryList").removeClass("active");
        $('[data-href="#HeaderCountryList"]').attr("aria-expanded","false");
      }
    }
    
    if(!$(event.target).closest('#HeaderLanguageList').length && !$(event.target).closest('[data-href="#HeaderLanguageList"]').length){
      if($('[data-href="#HeaderLanguageList"]').attr("aria-expanded") == "true") {
        $("#HeaderLanguageList").removeClass("active");
        $('[data-href="#HeaderLanguageList"]').attr("aria-expanded","false");
      }
    }
    
  });
  //Default Popover Javascript End
function ToggleIcon(){
			if (jQuery(window).width() <= 989)
			{
				
				jQuery(".footer_inner .footer-cms .title-footer").click(function(){
					jQuery(this).parent().toggleClass('active').parent().find('.footer-toggle').slideToggle('slow');
				});
		
			}else{
				jQuery(".footer_inner .footer-cms .title-footer").parent().find('ul').removeAttr('style');
				jQuery(".footer_inner .footer-cms .title-footer").removeClass('toggle-active');
				
			}	
	}


 $(document).ready(function () {
     $(".quickview-btn").click(function () {
         $('body').css('overflow', 'hidden');  //ADD THIS
     });

     $(document).on('click', '#ModalClose-quick-view', function () {
         $('body').css('overflow', 'auto');  //ADD THIS
     });
   
 });

  $(document).ready(function () {
    ToggleIcon();
     $(".cart-notification__close").click(function () {
         $('body').css('overflow', 'hidden');  //ADD THIS
     });

     $(document).on('click', '.cart-notification-wrapper', function () {
         $('body').css('overflow', 'auto');  //ADD THIS
     });
 });


   // Faq Page Script
   function toggleCRC (thisChevron,thisID,thisHead) {
        if($(thisChevron).hasClass("on")) {
            $(thisChevron).removeClass("on");
            $(thisChevron).css("transform","rotate(0deg)");
        } else {
        
        $(thisChevron).addClass("on");
            $(thisChevron).css("transform","rotate(180deg)");
        }
            $("#"+thisID).slideToggle( 600, "swing", function() {
            });
        }
    
        /* open accordian */
        $(".acc-head").click(function() {
        
            var expandThisID = $(this).data("section");
        var thisHead = $('.acc-head[data-section=' + expandThisID +']');
        var chevron = $('i[data-section=' + expandThisID +']');
        // close open chevrons
        $(".crc-chevron").each (function() {
        if ($(this).hasClass("on")) {
        }
        })
        // close open accordions
        
        $(".acc-body").each(function() {
        if ($(this).data("section") != expandThisID && $(this).is(":visible")) {
            $("#"+$(this).data("section")).slideToggle( 600, "swing", function() {
            });
            $("i[data-section=" + $(this).data("section") + ']').removeClass("on");
            $("i[data-section=" + $(this).data("section") + ']').css("transform","rotate(0deg)");
            }
        });
        
        $("#"+expandThisID+" button").removeClass("crc-close-anim");
        
        toggleCRC(chevron,expandThisID,thisHead);   
        });
    
        /* X functionality */
        $('.close').click(function() { // fa-times class
            $(this).addClass("crc-close-anim");
            var collapseThisID = $(this).data("section");
        //console.log(collapseThisID);
            var chevron = $('i[data-section=' + collapseThisID +']');
            var thisHead = $('.acc-head[data-section=' + collapseThisID +']');
            toggleCRC(chevron,collapseThisID,thisHead)	
        });


        function openTab(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent-cus");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks-cus");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}
if (document.querySelector('#tab-cus-active') !== null) {
document.getElementById("tab-cus-active").click();
}
/* Back to functionality Start */
var btn = $('#back-to-top');

    $(window).scroll(function() {
    if ($(window).scrollTop() > 300) {
        btn.addClass('show');
    } else {
        btn.removeClass('show');
    }
    });
    btn.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '300');
    });
/* Back to functionality End */

/* tab product */
$(document).ready(function () {
  $(".tab-content").hide();
  $(".tab-content:first").show();
  
  $(".tabs-slider .tab_item").click(function () {
      $(".tabs-slider .tab_item").removeClass("active");
      $(this).addClass("active");
      $(".tab-content").hide();
      var activeTab = $(this).attr("rel");
      $("#" + activeTab).show();
  });
  });
  
  $(document).ready(function () {
  $(".tab_slider").hide();
  $(".tab_slider:first").show();
  
  $(".tabs-slider .tab_item").click(function () {
      $(".tabs-slider .tab_item").removeClass("active");
      $(this).addClass("active");
      $(".tab_slider").hide();
      var activeTab = $(this).attr("rel");
      $("#" + activeTab).show();
  });
});

//newsletter popup cookies setting onclick checkbox start===============
  jQuery(document).ready(function() { 
    var cookie = false;
    var cookieContent = $('.cookie-disclaimer2');
    checkCookie();
     if (cookie === true) {
      cookieContent.hide();
      $('#myModal').modal('hide');
    }
    else{
      $('#myModal').modal('show');
    }
    function setCookie(dt_gdpr_name, cookie_value, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays * 24 *  60 * 60 * 1000));
      var expires = "expires=" + d.toGMTString();
      document.cookie = dt_gdpr_name + "=" + cookie_value + "; " + expires;
    }
    function getCookie(dt_gdpr_name) {
      var name = dt_gdpr_name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
      }
      return "";
    }
    function checkCookie() {
      var user = getCookie("dt_gdpr_name");
      if (user !== "") {        
        cookie = true;
      } else {        
        if (user !== "" && user !== null) {
          setCookie("cookie_value", "cookie_value", 365);
        }
      }
    }
    function deleteCookie() {
      setCookie('dt_gdpr_name', '', -1);
    }

     $(".accept-cookie2").click(function() {
      
        if ($(this).is(":checked")) {
          setCookie("dt_gdpr_name", "cookie_value", 365);     
          cookieContent.hide();
          $('#myModal').modal('hide');
          }
           else{
              deleteCookie();
              cookieContent.hide();
           }
    });
  });
//newsletter popup cookies setting onclick checkbox End===========================


// header main-menu js ===========================
$('.category-main-title').on('click', function(){
    $('.category-main-menu-toggle').slideToggle(500);
    $(this).toggleClass('rx-change');
  });

  function ltn__CategoryMenuToggle(){
    $('.category-main-menu-toggle .category-megamenu-dropdown > a').on('click', function(){
      if($(window).width() < 991){
        $(this).removeAttr('href');
        var element = $(this).parent('li');
        if (element.hasClass('open')) {
          element.removeClass('open');
          element.find('li').removeClass('open');
          element.find('ul').slideUp();
        }
        else {
          element.addClass('open');
          element.children('ul').slideDown();
          element.siblings('li').children('ul').slideUp();
          element.siblings('li').removeClass('open');
          element.siblings('li').find('li').removeClass('open');
          element.siblings('li').find('ul').slideUp();
        }
      }
    });
  ltn__CategoryMenuToggle();
};

$(function(){
  
  $('.category-megamenu-dropdown > a').on('click',function(event){
    
    event.preventDefault();
    $(this).toggleClass('selected');
    $(this).parent().find('ul').first().toggle(300);
    
    $(this).parent().siblings().find('ul').hide(200);
    
    //Hide menu when clicked outside
    $(this).parent().find('ul').parent().mouseleave(function(){ 
      var thisUI = $(this);
      $('html').click(function(){
        thisUI.children(".category-main-submenu").hide();
    thisUI.children("a").removeClass('selected');
               
        $('html').unbind('click');
      });
    });
  });
});